module.exports = __webpack_public_path__ + "static/media/34.fa7a35e0.jpg";